import debounce from "lodash/debounce";

import type { Track } from "@similarweb/tracking-provider";

import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import { allTrackers } from "app/services/track/track";

const DEBOUNCE_TIMEOUT = 500;

const createColumnsSelectionTrackingService = (trackEvent: Track) => {
    const trackColumnSettingsEvent = (eventName: string) => {
        trackEvent("column settings", "column picker", eventName);
    };

    const trackColumnPickerEvent = (action: string, eventName: string) => {
        trackEvent("column picker", action, eventName);
    };

    const trackColumnPickerButtonAction = (action: string, suggestionsCount: number) => {
        const buttonStatus = suggestionsCount > 0 ? "with suggestions" : "without suggestions";

        const eventName = createTrackingEventName("column picker button", buttonStatus);

        trackColumnPickerEvent(action, eventName);
    };
    return {
        columnPickerButton: {
            trackClicked(suggestionsCount: number) {
                trackColumnPickerButtonAction("click", suggestionsCount);
            },
            trackHovered(suggestionsCount: number) {
                trackColumnPickerButtonAction("hover", suggestionsCount);
            },
        },

        columnPickerLink: {
            trackClicked(...params: readonly (string | number)[]) {
                trackColumnPickerEvent("click", createTrackingEventName("column picker link", ...params));
            },
        },

        trackSearch: debounce((searchTerm: string) => {
            trackColumnSettingsEvent(`search/${searchTerm}`);
        }, DEBOUNCE_TIMEOUT),
        trackAddColumn(columnName: string) {
            trackColumnSettingsEvent(`add column/${columnName}`);
        },
        trackRemoveColumn(columnName: string) {
            trackColumnSettingsEvent(`remove/${columnName}`);
        },
        trackChangeCategory(category: string) {
            trackColumnSettingsEvent(`change category/${category}`);
        },
        trackApplyChanges(columnsCount: number) {
            trackColumnSettingsEvent(`apply/${columnsCount}`);
        },
    };
};

export const columnsSelectionTrackingService = createColumnsSelectionTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);
